import { FetchStoreState } from './mutations'

export * from './mutations'

const state: FetchStoreState = {}

export type DataState = typeof state

export default state
